import React from 'react';
export function Reveal() {
  return <section aria-labelledby="revelacion" className="w-full bg-cream" data-id="element-93" data-mp="2dgjy3k6rjbjh">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 py-16 lg:grid-cols-[1fr_1.1fr] lg:gap-20 lg:px-10 lg:py-24" data-id="element-94" data-mp="36puka4n4su8p">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/c3446ce8-10ec-40a8-a74d-473eccae3a7a.jpg" alt="Plantillas de juegos, tarjetas y cartelería de boda impresas sobre un mantel de lino" className="aspect-[3/2] w-full rounded-[1.5rem] object-cover" loading="lazy" data-id="element-95" data-mp="3bjpalqx8s7gr" />

        <div data-id="element-96" data-mp="2sqlgy5k0xum5">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-wine" data-id="element-97" data-mp="2sqv3tk9rvlnm">
            La revelación
          </p>
          <h2 id="revelacion" className="mt-5 font-display text-3xl font-semibold leading-tight text-ink sm:text-[2.6rem]" data-id="element-98" data-mp="2xriycfx7mkml">
            El secreto no está en gastar más en el DJ o en el buffet. Está en la{' '}
            <em className="italic text-wine" data-id="element-99" data-mp="2c56imzqvwfst">interacción psicológica.</em>
          </h2>
          <p className="mt-6 max-w-prose font-sans text-lg leading-relaxed text-muted" data-id="element-100" data-mp="283cj4usfdhu8">
            Después de analizar cientos de bodas, descubrimos que basta con darle a la gente una
            razón para hablar entre sí. Así nació el{' '}
            <strong className="font-semibold text-ink" data-id="element-101" data-mp="1y43tuf8i8re7">Wedding Bliss &amp; Fun System™</strong>: el
            primer sistema digital diseñado para eliminar el aburrimiento y el estrés de forma
            automática.
          </p>
          <p className="mt-5 max-w-prose font-sans text-lg leading-relaxed text-muted" data-id="element-102" data-mp="1oczhlna7rkn2">
            No son solo plantillas; es tu seguro de vida para que los invitados digan:
          </p>
          <p className="mt-6 font-display text-2xl italic leading-snug text-ink sm:text-3xl" data-id="element-103" data-mp="1fg8j7486vtpb">
            “Fue la mejor boda a la que he ido.”
          </p>
        </div>
      </div>
    </section>;
}